const guard = {
    invalid_input: 'İstek {{type}} geçersiz.',
    invalid_pagination: 'İstenen sayfalandırma değeri geçersiz.',
    can_not_get_tenant_id: 'İstekten kiracı kimliği alınamadı.',
    file_size_exceeded: 'Dosya boyutu aşıldı.',
    mime_type_not_allowed: 'MIME türü izin verilmiyor.',
};
export default guard;
